import Reflux from 'reflux';
import ShowData from 'shared/data/Show';
import ItemSetListData from 'shared/data/ItemSetList';
import ItemSetData from 'shared/data/ItemSet';

const async = { asyncResult: true },
  CuesheetActions = Reflux.createActions({
    clearScrollIndexes: {},
    setGridHeight: {},
    populate: async,
    populateFullScreen: async,
    /**
     * We have a different action CuesheetActions.updateAfterReconnect(), because .populate() has other side-effects,
     * like resetting the clock (other stores are listening on that action)
     */
    updateAfterReconnect: async,
    populateForGuest: async,
    clear: {},
    startEditingDataCell: {},
    updateColumnPersistent: async,
    setCollabCells: {},
    setCopyStateFromSession: {},
    deleteActualDurations: {},
    deleteActualDurationsPersistent: async,
  });

/**
 * Calling this grid instead of cuesheet it may or may not be a cuesheet type list
 *
 * @param teamId
 * @param eventId
 * @param showId
 * @returns {*}
 */
const loadGridData = (teamId, eventId, showId) => {
  return Promise.all([
    ShowData.get(teamId, eventId, showId),
    ItemSetListData.get(teamId, eventId, showId),
    ShowData.getGlobalElementShowItems(teamId, eventId, showId),
  ]).then((results) => {
    return {
      show: results[0],
      itemSetList: results[1],
      globalElementShowItems: results[2],
    };
  });
};

CuesheetActions.populate.listenAndPromise(loadGridData);
CuesheetActions.updateAfterReconnect.listenAndPromise(loadGridData);

CuesheetActions.populateForGuest.listenAndPromise((teamId, eventId, showId) => {
  return Promise.all([
    ShowData.getForGuest(teamId, eventId, showId),
    ItemSetListData.getForGuest(teamId, eventId, showId),
    ShowData.getGlobalElementShowItemsForGuest(teamId, eventId, showId),
  ]).then((results) => {
    return {
      show: results[0],
      itemSetList: results[1],
      globalElementShowItems: results[2],
    };
  });
});

CuesheetActions.populateFullScreen.listenAndPromise(ShowData.get);

CuesheetActions.updateColumnPersistent.listenAndPromise(
  ItemSetListData.updateColumn,
);

CuesheetActions.deleteActualDurationsPersistent.listenAndPromise(
  ItemSetData.deleteActualDurations,
);

export default CuesheetActions;
